import { type Snapshot } from "@/stores/snapshot";

/**
 * Read the currently-selected Socratic dialogue ID from an answer block's
 * snapshot.
 */
export function selectedDialogueIdFromSnapshot(
  snapshot: Snapshot | undefined
): string | null {
  return snapshot?.answerDialogueId ?? null;
}
